import React from "react";

const Vision = ({ data }) => {
    if (!data) return null;

    return (
        <section className="vision-section ">
            <div className="container">
                <div className="sec-title text-center">
                    <h2>{data.main_heading || "Vision And Objectives"}</h2>
                </div>

                <div className="row d-flex justify-content-start align-items-stretch">
                    {/* Vision Block */}
                    <div className="col-md-5 bg-vision text-white p-5 d-flex flex-column justify-content-center">
                        <div className="sec-title text-center py-2">
                            <h3 className="text-white">{data.vision_heading || "Our Vision"}</h3>
                        </div>
                        <div 
                            className="text-center"
                            dangerouslySetInnerHTML={{ __html: data.vision_content }} 
                        />
                    </div>

                    {/* Objectives Block */}
                    <div className="col-md-7 bg-mission text-white p-5">
                        <div className="sec-title text-center py-2">
                            <h3 className="text-white">{data.obj_heading || "Our Objectives"}</h3>
                        </div>

                        <p className="text-start">{data.obj_sub_line || "The Intern Care program aims to:"}</p>
                        <ul className="text-start" style={{ listStyleType: "none" }}>
                            {data.obj_list && data.obj_list.map((objective, index) => (
                                <li className="mb-2" key={index}>
                                    <i className="fa fa-dot-circle-o text-white me-2"></i>
                                    {objective}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Vision;